import { useSyncExternalStore } from 'react';

/**
 * Whether the app-wide "Add new product" drawer is open.
 *
 * One drawer for the whole app, hosted by the layout, so the shortcut and any
 * page's button open the same thing. A module value with listeners rather than
 * a context: the button on the Today page and the key handler in the layout
 * are the only two callers, and neither needs anything else from a provider.
 */
let open = false;
const listeners = new Set<() => void>();

function set(next: boolean) {
  if (open === next) return;
  open = next;
  for (const listener of listeners) listener();
}

export function openNewProduct(): void {
  set(true);
}

export function closeNewProduct(): void {
  set(false);
}

export function useNewProductOpen(): boolean {
  return useSyncExternalStore(
    (listener) => {
      listeners.add(listener);
      return () => listeners.delete(listener);
    },
    () => open,
    () => false,
  );
}
